
<ngx-simplebar class="mx-n3 px-4 file-manager-content-scroll">
  @if (loading) {
    <div class="mt-5">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }

  @if (!loading && conversation) {
    <!-- Start Header -->
    <div class="row py-1 mb-0">
      <div class="col-md-auto"><h3><i role="none" (click)="goBack()" title="Back to conversations" class="bx bx-arrow-back cursor-pointer"></i></h3></div>
      <div class="col-md"><h3>{{ conversation.name + ' (' + conversation.person.first_name + ' ' + conversation.person.last_name + ')' }}</h3></div>
      @if (conversation.status === 'WAITING' && conversation.file_type !== 'NONE' && !startedUpload && !startedRecord && !liveStatus) {
        <div class="col-md-auto">
          <button type="button" style="z-index: 1;" (click)="chooseAction('NONE')" class="btn btn-secondary waves-effect waves-light">Change Action</button>
        </div>
      }
      @if (conversation.status === 'COMPLETED' && !showLoadingData) {
        <div class="col-md-auto">
          <button type="button" style="z-index: 1;" (click)="openGenerateNewReportModal()" class="btn btn-info waves-effect waves-light"><i class="ri-add-line align-bottom me-1"></i> Generate New Report</button>
        </div>
      }
    </div>
    <!-- End Header -->
    @if (loadingPageData) {
      <div class="mt-5">
        <app-loading-spinner></app-loading-spinner>
      </div>
    }
    @if (!loadingPageData && conversation.status === 'WAITING') {
      <div class="row mt-3">
        @if (conversation.file_type === 'NONE') {
          <div class="col-12 text-center mb-3">
            <h1>Select Action</h1>
          </div>
          <div class="col-12 col-md-4">
            <div class="card card-body text-center" style="margin-bottom: unset; box-shadow: 0px 0px 0px 1px rgb(60 74 56 / 50%); height: 220px">
              <div class="avatar-sm mx-auto mb-3">
                <div class="avatar-title bg-success-subtle text-success fs-17 rounded">
                  <i class="ri-upload-line"></i>
                </div>
              </div>
              <h4 class="card-title">File upload</h4>
              <p class="card-text text-muted">Upload a pre-recorded video file for analysis.</p>
              <button (click)="chooseAction('UPLOAD')" class="btn btn-success mt-auto">Select</button>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="card card-body text-center" style="margin-bottom: unset; box-shadow: 0px 0px 0px 1px rgb(60 74 56 / 50%); height: 220px">
              <div class="avatar-sm mx-auto mb-3">
                <div class="avatar-title bg-success-subtle text-success fs-17 rounded">
                  <i class="ri-vidicon-2-line"></i>
                </div>
              </div>
              <h4 class="card-title">Record session</h4>
              <p class="card-text text-muted">Record the conversation and upload automatically for analysis.</p>
              <button (click)="chooseAction('RECORD')" class="btn btn-success mt-auto">Select</button>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="card card-body text-center" style="margin-bottom: unset; box-shadow: 0px 0px 0px 1px rgb(60 74 56 / 50%); height: 220px">
              <div class="avatar-sm mx-auto mb-3">
                <div class="avatar-title bg-success-subtle text-success fs-17 rounded">
                  <i class="ri-live-line"></i>
                </div>
              </div>
              <h4 class="card-title">Live Analysis (Coming Soon)</h4>
              <p class="card-text text-muted">Get real-time analysis results during a live recording.</p>
              <button (click)="chooseAction('LIVE')" class="btn btn-success mt-auto" disabled>Select</button>
            </div>
          </div>
        }
        @if (conversation.file_type === 'UPLOAD') {
          <app-upload-conversation-video [projectID]="projectId" [conversationID]="conversationID" (startedUploading)="onUploadStart($event)" (uploadComplete)="onUploadComplete()"></app-upload-conversation-video>
        }
        @if (conversation.file_type === 'RECORD') {
          <app-record-conversation-video [projectID]="projectId" [conversationID]="conversationID" (startedRecording)="onRecordStart($event)" (uploadComplete)="onUploadComplete()"></app-record-conversation-video>
        }
      </div>
    }
    @if (!loadingPageData && conversation.status === 'STARTED') {
      <div class="row mt-3">
        <div class="text-center mt-sm-5 pt-4 mb-4">
          <div class="mb-5">
            <h1 class="display-2 coming-soon-text">
              <span class="fixed-text">Recording</span>
              <span class="loading-dots-container me-5">
                <span class="loading-dots">{{ dots }}</span>
              </span>
            </h1>
          </div>
          <div>
            <div class="mt-5">
              <h4>
                <p class="text-muted">This session is already started.</p>
              </h4>
            </div>
          </div>
        </div>
      </div>
    }
    @if (!loadingPageData && conversation.status === 'ANALYZING') {
      <div class="row mt-3">
        <div class="text-center mt-sm-5 pt-4 mb-4">
          <div class="mb-5">
            <h1 class="display-2 coming-soon-text">
              <span class="fixed-text">ANALYZING</span>
              <span class="loading-dots-container me-5">
                <span class="loading-dots">{{ dots }}</span>
              </span>
            </h1>
          </div>
          <div>
            <div class="mt-5">
              <h4>
                <p class="text-muted">Come back later.</p>
                <p class="text-muted">the approximate time for analyze depends on the video length.</p>
              </h4>
            </div>
          </div>
        </div>
      </div>
    }
    @if (!loadingPageData && conversation.status === 'FAILED') {
      <div class="row mt-3">
        <div class="text-center mt-sm-5 pt-4 mb-4">
          <div class="mt-2">
            <lord-icon src="https://cdn.lordicon.com/jxzkkoed.json" trigger="loop" style="width:150px;height:150px"></lord-icon>
            <h4 class="mb-3 mt-4">Analyze failed</h4>
            <p class="text-muted fs-15 mb-4">Something went wrong while trying analyze the video!</p>
          </div>
        </div>
      </div>
    }
    @if (!loadingPageData && conversation.status === 'COMPLETED') {
      <div class="row">
        @if (showLoadingData) {
          <div class="text-center mt-sm-5 pt-4 mb-4">
            <div class="mb-5">
              <h1>Loading Data...</h1>
            </div>
            <div>
              <div class="mt-5">
                <div class="d-flex justify-content-center align-items-center">
                  <div class="progress animated-progress custom-progress progress-label p-0 w-50">
                    <div class="progress-bar bg-primary" role="progressbar" [style.width.%]="progress" [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100">
                      <div class="label">{{ progress }}%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (!showLoadingData) {
          <app-conversation-data [page_source]="'conversation'" [page_data]="page_data" [conversation]="conversation" [conversation_data]="conversationData" [targetReportId]="targetReportId" [allowSpecial]="allowSpecial" (reportOpened)="targetReportId = null" (updateReportsEvent)="handleUpdateReports($event)"></app-conversation-data>
        }
      </div>
    }
  }
</ngx-simplebar>

<app-generate-new-report #generateNewReport [page_source]="'conversation'" [page_data]="page_data" (updateReportsEvent)="handleUpdateReports($event)"></app-generate-new-report>